<template>
  <article v-if="article" class="page">
    <div class="container">
      <h1 class="mb-4">{{ article.title }}</h1>
      <div class="page-body">
        <div ref="pageBodyRef" v-html="article.body"></div>
        <div class="mt-12">
          <div class="text-small-caps mb-2 font-bold leading-4">
            {{ toLocaleDateTime(article.created_at) }}
          </div>
          <div class="text-small font-bold leading-4">
            Автор: {{ article.author }}
          </div>
        </div>
      </div>
    </div>
    <section class="section">
      <CommonBlocksPageFooterBlocks />
    </section>
  </article>
</template>

<script setup>
const route = useRoute();
const { toLocaleDateTime } = useUtils();

const pageBodyRef = ref(null);
const { data: article } = useMagazineArticles(route.params.slug);

useErrorHandler(() => article.failureReason?.value?.status);

onMounted(() => renderImageFooter(pageBodyRef.value));

useHead(
  computed(() => ({
    title: `${article.value?.title ? article.value?.title + ' |' : ''} РВИО`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: `${article.value?.title}. Статья из журнала Российского Военно-исторического общества.`,
      },
    ],
  })),
);
</script>
